import React from 'react'
import Index from '../_components/Cost/Index'

const Cost = () => {
  return (
    <Index />
  )
}

export default Cost